"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8152,9534],{

/***/ 70794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CN": function() { return /* binding */ bloomreachHomePagePixel; },
/* harmony export */   "KZ": function() { return /* binding */ bloomreachSuggestEventPixel; },
/* harmony export */   "Lh": function() { return /* binding */ bloomreachPageViewPixel; },
/* harmony export */   "PP": function() { return /* binding */ bloomreachAddToCartEvent; },
/* harmony export */   "Pn": function() { return /* binding */ bloomreachContentPageViewPixel; },
/* harmony export */   "eP": function() { return /* binding */ bloomreachCategoryPagePixel; },
/* harmony export */   "f7": function() { return /* binding */ bloomreachSearchEvent; },
/* harmony export */   "l0": function() { return /* binding */ bloomreachSearchPagePixel; },
/* harmony export */   "mg": function() { return /* binding */ bloomreachConversionEvent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var _services_Configuration__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16977);
/* harmony import */ var _services_Configuration__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_services_Configuration__WEBPACK_IMPORTED_MODULE_0__);



var generateBloomreachBaseScript = function(customScript) {
    var baseScript = "\n    var brtrk = document.createElement('script');\n    brtrk.type = 'text/javascript';\n    brtrk.async = true;\n    brtrk.src = \"//cdn.brcdn.com/v1/br-trk-".concat(_services_Configuration__WEBPACK_IMPORTED_MODULE_0__.BLOOMREACH_ACCOUNT_ID, ".js\";\n    var s = document.getElementsByTagName('script')[0];\n    s.parentNode.insertBefore(brtrk, s);\n    var br_data = br_data || {};\n    br_data.acct_id = ").concat(_services_Configuration__WEBPACK_IMPORTED_MODULE_0__.BLOOMREACH_ACCOUNT_ID, ";\n    br_data.test_data = '").concat(_services_Configuration__WEBPACK_IMPORTED_MODULE_0__.IS_BLOOMREACH_TEST_ENV, "';\n  ");
    return customScript ? "".concat(baseScript, " ").concat(customScript) : baseScript;
};
var bloomreachConversionEvent = function(customerId, orderId, orderTotal, lineItems) {
    var updatedLineItems = lineItems.map(function(_param) {
        var prod_id = _param.sku, sku = _param.sku, price = _param.subtotalPrice, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
            "sku",
            "sku",
            "subtotalPrice"
        ]);
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
            prod_id: prod_id,
            sku: sku,
            price: price
        }, rest);
    });
    var bloomreachScript = document.createElement("script");
    bloomreachScript.setAttribute("type", "text/javascript");
    bloomreachScript.textContent = "\n          ".concat(generateBloomreachBaseScript(), "\n          br_data.ptype = 'other'\n          br_data.user_id = ").concat(customerId, "\n          br_data.is_conversion = ", 1, "\n          br_data.basket_value = ").concat(orderTotal, "\n          br_data.order_id = ").concat(orderId, "\n          br_data.basket = {\n          'items':\n           ").concat(JSON.stringify(updatedLineItems), "\n          ,\n        };");
    document.body.appendChild(bloomreachScript);
};
var bloomreachSearchPagePixel = function(title, userId) {
    var ref;
    var bloomreachScript = document.createElement("script");
    bloomreachScript.setAttribute("type", "text/javascript");
    bloomreachScript.setAttribute("id", "SearchPageViewPixel");
    bloomreachScript === null || bloomreachScript === void 0 ? void 0 : (ref = bloomreachScript.parentNode) === null || ref === void 0 ? void 0 : ref.removeChild(bloomreachScript);
    bloomreachScript.textContent = "\n          ".concat(generateBloomreachBaseScript(), '\n          br_data.ptype = "search";\n          br_data.user_id = \'').concat(userId, "';\n          br_data.search_term = '").concat(title, "'; \n        ");
    document.body.appendChild(bloomreachScript);
};
var bloomreachSearchEvent = function(searchString) {
    if (window.BrTrk) {
        var ref, ref1;
        var searchData = {
            q: "",
            catalogs: []
        };
        searchData.q = searchString;
        searchData.catalogs = [
            {
                "name": "onekingslane"
            }
        ];
        (ref = window.BrTrk) === null || ref === void 0 ? void 0 : (ref1 = ref.getTracker) === null || ref1 === void 0 ? void 0 : ref1.call(ref).logEvent("suggest", "submit", searchData, {}, true);
    }
};
var bloomreachAddToCartEvent = function(sku) {
    if (window.BrTrk) {
        var ref, ref1;
        (ref = window.BrTrk) === null || ref === void 0 ? void 0 : (ref1 = ref.getTracker) === null || ref1 === void 0 ? void 0 : ref1.call(ref).logEvent("cart", "click-add", {
            "prod_id": sku,
            "sku": sku
        });
    }
};
var bloomreachPageViewPixel = function(product, customerId, sku) {
    if (!product) {
        return;
    }
    var bloomreachScript = document.createElement("script");
    bloomreachScript.setAttribute("id", "PDPPixelScript");
    bloomreachScript.textContent = "\n      ".concat(generateBloomreachBaseScript(), '\n      if (document.referrer !== document.location.href){\n            br_data.ptype = "product";\n            br_data.prod_name = \'').concat(product === null || product === void 0 ? void 0 : product.name, "';\n            br_data.prod_id = '").concat(sku, "';\n            br_data.user_id = '").concat(customerId, "';\n            br_data.sku = '").concat(sku, "';\n          }");
    var script = document.getElementById("PDPPixelScript");
    if (script === null) {
        document.body.appendChild(bloomreachScript);
    }
};
var bloomreachContentPageViewPixel = function(pageTitle) {
    var bloomreachScript = document.createElement("script");
    bloomreachScript.textContent = "\n          ".concat(generateBloomreachBaseScript(), "\n          br_data.catalogs = [ { name : 'onekingslane_discovery' } ];\n          br_data.item_name = '").concat(pageTitle, '\';\n          br_data.ptype = "content";\n        ');
    document.body.appendChild(bloomreachScript);
};
var bloomreachSuggestEventPixel = function(searchString, searchSuggestion) {
    var searchData = {
        q: "",
        aq: "",
        catalogs: []
    };
    searchData.q = searchSuggestion;
    searchData.aq = searchString;
    searchData.catalogs = [
        {
            "name": "onekingslane"
        }
    ];
    if (window.BrTrk) {
        var ref, ref1;
        (ref = window.BrTrk) === null || ref === void 0 ? void 0 : (ref1 = ref.getTracker) === null || ref1 === void 0 ? void 0 : ref1.call(ref).logEvent("suggest", "click", searchData, {}, true);
    }
};
var bloomreachCategoryPagePixel = function(breadcrumbs) {
    if (!breadcrumbs) {
        return;
    }
    var bloomreachScript = document.createElement("script");
    bloomreachScript.setAttribute("type", "text/javascript");
    bloomreachScript.textContent = "\n  if (document.referrer !== document.location.href){\n        ".concat(generateBloomreachBaseScript(), '\n          br_data.ptype = "category";\n          br_data.cat_id = ').concat(breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs.slice(-1)[0].id, ";\n          br_data.cat = '").concat(breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs.map(function(obj) {
        return obj.id;
    }).join("|"), "';\n  }");
    document.body.appendChild(bloomreachScript);
};
var bloomreachHomePagePixel = function() {
    var bloomreachScript = document.createElement("script");
    bloomreachScript.setAttribute("type", "text/javascript");
    bloomreachScript.textContent = "\n  if (document.referrer !== document.location.href){\n        ".concat(generateBloomreachBaseScript(), '\n          br_data.ptype = "homepage";  }');
    document.body.appendChild(bloomreachScript);
};


/***/ }),

/***/ 28152:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Navbar_SearchBox; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./helpers/common.ts
var common = __webpack_require__(32054);
;// CONCATENATED MODULE: ./helpers/Keys.ts
var trap = function(event, keyOrList, block, otherwise) {
    var keysSearching = Array.isArray(keyOrList) ? keyOrList : [
        keyOrList
    ];
    if ([
        event.keyCode,
        event.charCode
    ].some(function(code) {
        return keysSearching.includes(code);
    })) {
        event.preventDefault();
        if (typeof block === "function") {
            block(event);
        }
    } else if (typeof otherwise === "function") {
        otherwise(event);
    }
};
/* harmony default export */ var Keys = ({
    ENTER: 13,
    ESCAPE: 27,
    UP: 38,
    DOWN: 40,
    trap: trap
});

// EXTERNAL MODULE: ./services/Log.ts
var Log = __webpack_require__(27429);
// EXTERNAL MODULE: ./helpers/allPromisesWithRetries.ts
var allPromisesWithRetries = __webpack_require__(48080);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@csc/dls/Link.js
var Link = __webpack_require__(97638);
// EXTERNAL MODULE: ./node_modules/@csc/dls/Text.js
var Text = __webpack_require__(45468);
// EXTERNAL MODULE: ./node_modules/@csc/dls/IconRenderer.js
var IconRenderer = __webpack_require__(99821);
// EXTERNAL MODULE: ./node_modules/@csc/dls/Icons/SearchIcon.js
var SearchIcon = __webpack_require__(49810);
// EXTERNAL MODULE: ./components/ScriptIntegrations/BloomreachEvents.tsx
var BloomreachEvents = __webpack_require__(70794);
;// CONCATENATED MODULE: ./components/Sitewide/Navbar/SearchBox/index.tsx


















var AlphanumericInput = dynamic_default()(__webpack_require__.e(/* import() */ 3008).then(__webpack_require__.bind(__webpack_require__, 93008)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(93008)
            ];
        }
    }
});
var CategoryResult = dynamic_default()(__webpack_require__.e(/* import() */ 8767).then(__webpack_require__.bind(__webpack_require__, 8767)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8767)
            ];
        }
    }
});
var ProductResult = dynamic_default()(__webpack_require__.e(/* import() */ 3825).then(__webpack_require__.bind(__webpack_require__, 33825)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(33825)
            ];
        }
    }
});
var upcase = function(s) {
    return s.slice(0, 1).toUpperCase() + ((s === null || s === void 0 ? void 0 : s.slice(1)) || "").toLowerCase();
};
var disambiguatedName = function(param) {
    var name = param.name, url = param.url;
    var tokenLength = name.split(" ").length;
    var partsFromUrl = url.replace(/^\/[a-z]-\d+-/, "").split("-");
    return "".concat(name, " (").concat(partsFromUrl.slice(0, partsFromUrl.length - tokenLength).map(upcase).join(" "), ")");
};
var disambiguate = function(categoryEntries) {
    var ZERO_HASH = {};
    var nameHashTable = categoryEntries.reduce(function(hash, entry) {
        // eslint-disable-next-line no-param-reassign
        hash[entry.source.data.name] = hash[entry.source.data.name] || [];
        hash[entry.source.data.name].push(entry);
        return hash;
    }, ZERO_HASH);
    return categoryEntries.map(function(entry) {
        var name = nameHashTable[entry.source.data.name].length > 1 ? disambiguatedName({
            name: entry.source.data.name,
            url: entry.source.data.custom_url.url
        }) : entry.source.data.name;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, entry), {
            name: name
        });
    });
};
var renderableResults = function(_param) {
    var category = _param.category, product = _param.product, redirectUrl = _param.redirectUrl, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "category",
        "product",
        "redirectUrl"
    ]);
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
        category: disambiguate(category),
        product: product,
        redirectUrl: redirectUrl
    });
};
var anyResults = function(result) {
    return [
        result === null || result === void 0 ? void 0 : result.category,
        result === null || result === void 0 ? void 0 : result.inspiration,
        result === null || result === void 0 ? void 0 : result.inspiration_static,
        result === null || result === void 0 ? void 0 : result.product, 
    ].some(function(piece) {
        return piece === null || piece === void 0 ? void 0 : piece.length;
    });
};
var SearchBox = function(param) {
    var _id = param.id, id = _id === void 0 ? "SearchBox" : _id, query = param.query, setQuery = param.setQuery, onFocus = param.onFocus, onBlur = param.onBlur;
    var ref, ref1;
    var ref2 = (0,react.useState)(null), searchResult = ref2[0], setSearchResult = ref2[1];
    var ref3 = (0,react.useState)(false), shouldBeVisible = ref3[0], setShouldBeVisible = ref3[1];
    var searchNodeRef = (0,react.useRef)(null);
    var ref4 = (0,react.useState)(null), mostRecentResponse = ref4[0], setMostRecentResponse = ref4[1];
    var onKeyUp = function(param) {
        var keyCode = param.keyCode;
        if (keyCode === Keys.ESCAPE) {
            setShouldBeVisible(false);
        }
    };
    var handleSubmit = function(e) {
        e.preventDefault();
        (0,BloomreachEvents/* bloomreachSearchEvent */.f7)(query);
        if (query) {
            window.location.href = "/search.php?query=".concat(query || "", "&sort=relevance");
        }
    };
    (0,react.useEffect)(function() {
        if ((mostRecentResponse === null || mostRecentResponse === void 0 ? void 0 : mostRecentResponse.query) === query) {
            var renderable = renderableResults(mostRecentResponse.response);
            setSearchResult((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, renderable), {
                redirectText: mostRecentResponse.query
            }));
            setShouldBeVisible(anyResults(renderable));
            try {
                var content_ids = mostRecentResponse.response.product.map(function(param) {
                    var match = param.match;
                    return "".concat(match).split("~")[1] || "";
                });
                var contents = content_ids.map(function(sku) {
                    return {
                        id: sku,
                        quantity: 1,
                        item_price: null
                    };
                });
                (0,allPromisesWithRetries/* default */.Z)(function() {
                    return [
                        __webpack_require__.e(/* import() */ 9366).then(__webpack_require__.bind(__webpack_require__, 11267))
                    ];
                }).then(function(param) {
                    var _param = (0,_sliced_to_array/* default */.Z)(param, 1), ref = _param[0], Facebook = ref.default;
                    return Facebook.search({
                        search_string: mostRecentResponse === null || mostRecentResponse === void 0 ? void 0 : mostRecentResponse.query,
                        content_ids: content_ids,
                        contents: contents
                    });
                }).catch(Log/* error */.vU);
            } catch (err) {
                (0,Log/* error */.vU)("Facebook Pixel Error Failed to send Search event", err);
            }
        }
    }, [
        mostRecentResponse,
        query
    ]);
    (0,react.useEffect)(function() {
        var update = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var ref, ref1, Search, response;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.t0 = _sliced_to_array/* default */.Z;
                            _ctx.next = 3;
                            return (0,allPromisesWithRetries/* default */.Z)(function() {
                                return [
                                    Promise.all(/* import() */[__webpack_require__.e(9638), __webpack_require__.e(5621)]).then(__webpack_require__.bind(__webpack_require__, 35621))
                                ];
                            });
                        case 3:
                            _ctx.t1 = _ctx.sent;
                            ref = (0, _ctx.t0)(_ctx.t1, 1);
                            ref1 = ref[0];
                            Search = ref1.default;
                            _ctx.next = 9;
                            return Search.suggest((0,common.removeSpecialChars)(query.trim()));
                        case 9:
                            response = _ctx.sent;
                            setMostRecentResponse({
                                query: query,
                                response: response
                            });
                        case 11:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function update() {
                return _ref.apply(this, arguments);
            };
        }();
        setShouldBeVisible(!!query);
        if (query) {
            update().catch(Log/* error */.vU);
        }
    }, [
        query,
        setMostRecentResponse,
        setShouldBeVisible
    ]);
    (0,react.useEffect)(function() {
        var handleClick = function(param) {
            var target = param.target;
            try {
                var ref;
                var shouldBe = searchNodeRef === null || searchNodeRef === void 0 ? void 0 : (ref = searchNodeRef.current) === null || ref === void 0 ? void 0 : ref.contains(target);
                setShouldBeVisible(!!shouldBe);
            } catch (err) {
                (0,Log/* error */.vU)("SearchBar failed", err);
            }
        };
        document.addEventListener("click", handleClick);
        return function() {
            return document.removeEventListener("click", handleClick);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        searchNodeRef === null || searchNodeRef === void 0 ? void 0 : searchNodeRef.current,
        setShouldBeVisible
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: searchNodeRef,
        className: "relative search-input-parent",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                "data-testid": "quick-search-form",
                className: "relative",
                action: "/search.php",
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AlphanumericInput, {
                        className: "SearchBarInput",
                        type: "text",
                        id: id,
                        "data-search-quick": true,
                        "data-error-message": "Search field cannot be empty.",
                        placeholder: "Search",
                        label: "Search",
                        autoComplete: "off",
                        value: query,
                        onKeyUp: onKeyUp,
                        onChange: function(param) {
                            var value = param.target.value;
                            (0,Log/* log */.cM)("setQuery: ".concat(value));
                            setQuery(value);
                        },
                        onFocus: function(e) {
                            onFocus(e);
                            setShouldBeVisible(anyResults(searchResult));
                        },
                        onBlur: onBlur,
                        required: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "absolute right-0 transform top-1/2 -translate-y-1/2 mr-2",
                        type: "submit",
                        "aria-label": "submit",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconRenderer["default"], {
                            IconComponent: SearchIcon/* default */.ZP,
                            size: "sm"
                        })
                    })
                ]
            }),
            shouldBeVisible && searchResult && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "TypeAheadResult",
                className: "top-full items-center align-baseline m-0 p-0 border-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "typehead z-110 w-full border-black border absolute top-full",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        children: [
                            searchResult.redirectUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.ZP, {
                                            href: searchResult.redirectUrl,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                                size: "lg",
                                                bold: true,
                                                className: "capitalize mb-1",
                                                children: searchResult.redirectText
                                            })
                                        })
                                    })
                                })
                            }) : null,
                            ((ref = searchResult.category) === null || ref === void 0 ? void 0 : ref.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    "Categories",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        children: searchResult.category.slice(0, 5).map(function(category) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryResult, {
                                                category: category,
                                                query: query
                                            }, category.source.data.id);
                                        })
                                    })
                                ]
                            }) : null,
                            (searchResult === null || searchResult === void 0 ? void 0 : (ref1 = searchResult.product) === null || ref1 === void 0 ? void 0 : ref1.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "see_all",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "/search.php?query=".concat(encodeURIComponent(query)),
                                            children: "See All"
                                        })
                                    }),
                                    "Products",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        children: searchResult.product.slice(0, 7).map(function(product) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductResult, {
                                                product: product,
                                                query: query
                                            }, product.source.data.id);
                                        })
                                    })
                                ]
                            }) : null
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Navbar_SearchBox = (SearchBox);


/***/ }),

/***/ 99821:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var React = __webpack_require__(67294);
function _interopDefaultLegacy(e) {
    return e && typeof e === "object" && "default" in e ? e : {
        "default": e
    };
}
var React__default = /*#__PURE__*/ _interopDefaultLegacy(React);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++){
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
var genSize = function genSize(size) {
    switch(size){
        case "2xl":
            return "w-32 h-32";
        //512x512
        case "xl":
            return "w-16 h-16";
        //64x64
        case "lg":
            return "w-8 h-8";
        //32x32
        case "md":
            return "w-5 h-5";
        //20x20
        case "sm":
            return "w-4 h-4";
        //16x16
        case "xxs":
            return "w-2 h-2";
        //8x8
        case "xs":
        default:
            //Default must be the last
            return "w-3 h-3";
    }
};
var IconRenderer = function IconRenderer(_a) {
    var IconComponent = _a.IconComponent, _b = _a.size, size = _b === void 0 ? "md" : _b, color = _a.color, loadingStyle = _a.loadingStyle, className = _a.className, rest = __rest(_a, [
        "IconComponent",
        "size",
        "color",
        "loadingStyle",
        "className"
    ]);
    var sizeClass = size && genSize(size);
    var colorStyle = color ? {
        fill: color
    } : {};
    var loadingClass = loadingStyle && "animate-".concat(loadingStyle);
    return /*#__PURE__*/ React__default["default"].createElement(IconComponent, _extends({
        style: colorStyle,
        className: "".concat(color ? color : "fill-current", " ").concat(sizeClass ? sizeClass : "", " ").concat(loadingClass ? loadingClass : "", " ").concat(className ? className : "")
    }, rest));
};
exports.IconRenderer = IconRenderer;
exports["default"] = IconRenderer; //# sourceMappingURL=IconRenderer.js.map


/***/ }),

/***/ 49810:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
var React = __webpack_require__(67294);
function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function(k) {
            if (k !== "default") {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function get() {
                        return e[k];
                    }
                });
            }
        });
    }
    n["default"] = e;
    return Object.freeze(n);
}
var React__namespace = /*#__PURE__*/ _interopNamespace(React);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var SvgSearchIcon = function SvgSearchIcon(props) {
    return /*#__PURE__*/ React__namespace.createElement("svg", _extends({
        width: "1em",
        height: "1em",
        viewBox: "0 0 64 64",
        fill: "none"
    }, props), /*#__PURE__*/ React__namespace.createElement("g", {
        transform: "matrix(3.7799134,0,0,3.7795273,0.35362482,-3.3639213)"
    }, /*#__PURE__*/ React__namespace.createElement("path", {
        fill: "#999",
        d: "m 16.633832,16.622362 -4.071326,-4.071326 a 7.1116883,7.1116883 0 0 0 1.617472,-4.5240804 c 0,-3.9399935 -3.196925,-7.13691802 -7.1369187,-7.13691802 -3.9399937,0 -7.13691815,3.19692452 -7.13691815,7.13691802 0,3.9399934 3.19346845,7.1369194 7.13691815,7.1369194 a 7.099246,7.099246 0 0 0 4.5206237,-1.614016 l 4.071326,4.06787 a 0.70505369,0.70505369 0 1 0 0.998823,-0.995367 z M 7.0430593,13.743403 c -3.155451,0 -5.7199029,-2.564452 -5.7199029,-5.7164474 0,-3.1519947 2.5644519,-5.7199027 5.7199029,-5.7199027 3.1554507,0 5.7199027,2.567908 5.7199027,5.7199027 0,3.1519954 -2.567908,5.7164474 -5.7199027,5.7164474 z",
        style: {
            strokeWidth: "0.0345612"
        }
    })));
};
__webpack_unused_export__ = SvgSearchIcon;
exports.ZP = SvgSearchIcon; //# sourceMappingURL=SearchIcon.js.map


/***/ }),

/***/ 97638:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
var React = __webpack_require__(67294);
function _interopDefaultLegacy(e) {
    return e && typeof e === "object" && "default" in e ? e : {
        "default": e
    };
}
var React__default = /*#__PURE__*/ _interopDefaultLegacy(React);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++){
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
var Link = function Link(_a) {
    var href = _a.href, _b = _a.target, target = _b === void 0 ? "_self" : _b, _c = _a.underline, underline = _c === void 0 ? true : _c, _onClick = _a.onClick, _d = _a.className, className = _d === void 0 ? "" : _d;
    _a.iconColor;
    _a.rightSideIcon;
    var children = _a.children, rest = __rest(_a, [
        "href",
        "target",
        "underline",
        "onClick",
        "className",
        "iconColor",
        "rightSideIcon",
        "children"
    ]);
    return /*#__PURE__*/ React__default["default"].createElement("a", _extends({
        className: "".concat(!!className ? className : "", " ").concat(underline ? "underline" : "no-underline", " cursor-pointer hover:text-accent-2"),
        href: href,
        target: target,
        onClick: function onClick(e) {
            var _$_a, _b;
            _onClick === null || _onClick === void 0 ? void 0 : _onClick(e);
            if (target === "_blank") {
                // TODO: define a better way to avoid iframe target _blank restriction
                try {
                    if (window.self !== window.top) {
                        // Inside Iframe
                        (_$_a = e === null || e === void 0 ? void 0 : e.preventDefault) === null || _$_a === void 0 ? void 0 : _$_a.call(e);
                        window.open(href);
                    }
                } catch (_c) {
                    //  Fail to access window may be due to frame constrains
                    try {
                        (_b = e === null || e === void 0 ? void 0 : e.preventDefault) === null || _b === void 0 ? void 0 : _b.call(e);
                        window.open(href);
                    } catch (error) {
                        console.error("Failed to trigger iframe link target _blank\n".concat(error));
                    }
                }
            }
        }
    }, rest), children);
};
exports.rU = Link;
exports.ZP = Link; //# sourceMappingURL=Link.js.map


/***/ }),

/***/ 45468:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
var React = __webpack_require__(67294);
function _interopDefaultLegacy(e) {
    return e && typeof e === "object" && "default" in e ? e : {
        "default": e
    };
}
var React__default = /*#__PURE__*/ _interopDefaultLegacy(React);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++){
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
var ThemeContext = /*#__PURE__*/ React.createContext({
    themeId: "",
    typographyComponents: {},
    brandVariables: {}
});
var useTheme = function useTheme() {
    return React.useContext(ThemeContext);
};
var TagRenderer = function TagRenderer(_a) {
    var children = _a.children, textTag = _a.textTag, rest = __rest(_a, [
        "children",
        "textTag"
    ]);
    if (typeof textTag === "string") {
        switch(textTag){
            case "h1":
                return /*#__PURE__*/ React__default["default"].createElement("h1", rest, children);
            case "h2":
                return /*#__PURE__*/ React__default["default"].createElement("h2", rest, children);
            case "h3":
                return /*#__PURE__*/ React__default["default"].createElement("h3", rest, children);
            case "h4":
                return /*#__PURE__*/ React__default["default"].createElement("h4", rest, children);
            case "h5":
                return /*#__PURE__*/ React__default["default"].createElement("h5", rest, children);
            case "h6":
                return /*#__PURE__*/ React__default["default"].createElement("h6", rest, children);
            case "span":
                return /*#__PURE__*/ React__default["default"].createElement("span", rest, children);
            case "p":
            default:
                return /*#__PURE__*/ React__default["default"].createElement("p", rest, children);
        }
    }
    return /*#__PURE__*/ React__default["default"].createElement("p", rest, children);
};
var LegacyText = function LegacyText(_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b, _c = _a.size, size = _c === void 0 ? "md" : _c, _d = _a.bold, bold = _d === void 0 ? false : _d, _e = _a.link, link = _e === void 0 ? false : _e;
    _a.id;
    var children = _a.children, _g = _a.textTag, textTag = _g === void 0 ? "p" : _g, rest = __rest(_a, [
        "className",
        "size",
        "bold",
        "link",
        "id",
        "children",
        "textTag"
    ]);
    var classes = "".concat(!!className ? className : "", " text-body-").concat(size, "-").concat(!!link ? "link" : !!bold ? "bold" : "normal");
    return /*#__PURE__*/ React__default["default"].createElement(TagRenderer, _extends({
        className: classes,
        textTag: textTag
    }, rest), children);
};
var Text = function Text(_a) {
    var _b;
    var textId = _a.textId, className = _a.className, children = _a.children, _c = _a.textTag, textTag = _c === void 0 ? "p" : _c, rest = __rest(_a, [
        "textId",
        "className",
        "children",
        "textTag"
    ]);
    var typographyComponents = useTheme().typographyComponents;
    if (!textId || !typographyComponents) {
        return /*#__PURE__*/ React__default["default"].createElement(LegacyText, _extends({
            className: className,
            textTag: textTag
        }, rest), children);
    }
    var props = __assign({
        className: "".concat(className || "", " ").concat(textId)
    }, rest);
    var inputTag = textTag || ((_b = typographyComponents === null || typographyComponents === void 0 ? void 0 : typographyComponents[textId]) === null || _b === void 0 ? void 0 : _b.htmlComponent);
    return /*#__PURE__*/ React__default["default"].createElement(TagRenderer, _extends({
        textTag: inputTag
    }, props), children);
};
__webpack_unused_export__ = LegacyText;
__webpack_unused_export__ = Text;
exports.ZP = Text; //# sourceMappingURL=Text.js.map


/***/ }),

/***/ 99534:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ })

}]);